import React from 'react';
import { Button, Typography } from '@/components/common';

interface Props {
	isSubmitting: boolean;
	onCancel: () => void;
	onConfirm: () => void;
	confirmInert?: boolean;
}

export const DeclineConfirmCard: React.FC<Props> = ({
	isSubmitting,
	onCancel,
	onConfirm,
	confirmInert = false,
}) => {
	return (
		<div className="relative z-10 w-full max-w-[384px] rounded-[32px] bg-white py-8 px-10 flex flex-col gap-6 shadow-shadow2">
			<div className="flex flex-col gap-6">
				<Typography type="semibold-16" className="!text-left">
					Are you sure you want to decline?
				</Typography>
				<Typography type="regular-14" className="text-gray-35 !text-left">
					Declining to sign this document may affect your ability to participate
					in this case.
				</Typography>
			</div>
			<div className="flex items-center gap-4 justify-between">
				<Button
					size="fit"
					label="Cancel"
					type="button"
					decoration="secondary"
					disabled={isSubmitting}
					className="!w-auto lg:!w-fit !h-[30px]"
					onClick={onCancel}
				/>
				<Button
					size="fit"
					label="Confirm"
					type="button"
					decoration="danger-outline"
					disabled={isSubmitting}
					loading={isSubmitting}
					className={
						confirmInert
							? '!w-auto lg:!w-fit !h-[30px] pointer-events-none'
							: '!w-auto lg:!w-fit !h-[30px]'
					}
					onClick={onConfirm}
				/>
			</div>
		</div>
	);
};
